import { createModalStore } from '#pplx/frontend/aether/modals/internal/createModalStore.js';
import { createContext } from 'react';
export const ModalStoreContext = createContext(undefined);
ModalStoreContext.displayName = 'ModalStoreContext';
//# sourceMappingURL=ModalStoreContext.js.map